package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project.list

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Floor
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Room
import org.hs_soft.runmynesto.pages.components.Separator

@Composable
fun Floors(
    isExpandAll: Boolean,
    windowSizeMode: WindowSizeModeEnum,
    floors: List<Floor?>,
    selectedRestaurantRoom: Room?,
    onFloorClick: () -> Unit,
    onRoomClick: (Room?) -> Unit,

) {
    floors.forEachIndexed {index,model->
        Column(
            modifier = Modifier
                .fillMaxWidth()
        )
        {
            FloorItem(
                windowSizeMode=windowSizeMode,
                isExpandAll = isExpandAll,
                floor =  model,
                content = {
                    Column(
                        Modifier.fillMaxWidth()
                    ){
                        if (model?.rooms?.size!=0)
                            Separator()

                        Rooms(
                            rooms=model?.rooms?: listOf(),
                            selectedRestaurantRoom=selectedRestaurantRoom,
                            windowSizeMode=windowSizeMode,
                            isExpandAll=true,
                            onRoomClick = {
                                onRoomClick(it)
                            }
                        )
                    }

                },
                onFloorClick = {
                    onFloorClick()
                }
            )

            if (index==floors.size-1){
                Box(
                    modifier = Modifier.height(Dimen.mediumPadding)
                )
            }
        }


    }

}